module.exports = __webpack_public_path__ + "img/qrcode.6d29dd65.svg";